import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service'; 
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  private error = {
    hasError: false,
    errorMessage: ''
  };

	loginData = {
		email: "",
		password: ""
  }

  private username: string;
  private videoList: Array<any>;

  constructor(
    private userService:UserService,
    private router: Router
  ) { }



  ngOnInit() {
  }

  loginUser():void{
    this.userService.login(this.loginData.email,this.loginData.password)
    .then((user)=>{
      console.log(user);
      localStorage.setItem('user',JSON.stringify(user));
      this.router.navigate(['dashboard']);
    },(error)=>{
      this.error.hasError = true;
      this.error.errorMessage = error;
    })
  } 
}



// WEBPACK FOOTER //
// ./src/app/guest/login/login.component.ts